site.sitebarToogle = {
	init: function() {
		$('#sidebarToggle').click(function(e) {
			e.stopPropagation();
			e.preventDefault();

			var sidebarOpen = $('body').hasClass('sidebar-open');
			site.sitebarToogle.sidebarToggle(e, sidebarOpen);


			$('#sidebar-wrapper').on('click', function(e) {
				e.stopPropagation();
			});

			$('body.sidebar-open').on('click', function (e) {
				$('body').removeClass('sidebar-open');
				$('#wrapper').addClass('toggled');
			});

		});
	},
	// Toggle sidebar
	sidebarToggle: function(e, sidebarOpen) {
		$('body').toggleClass('sidebar-open');
		$('#wrapper').toggleClass('toggled');
		if ($('body').is('.pantanir-open')) {
			$('#pantanirToggle').trigger('click');
		}
	}
};
site.inits.push('site.sitebarToogle.init()');